import '../vendor/owl.carousel.min.js';

const carousel = {
	$this: $( '.js-carousel-slider' ),
};

carousel.init = function() {

	const owl = carousel.$this.owlCarousel({
      items: 2,
      merge: false,
      loop: true,
      margin: 0,
      lazyLoad: true,
      center: false,
		dots: false,
		nav: false,
		onInitialized: callback
    });

		$('.js-owl-next').on( 'click', function(e) {
			e.preventDefault();
			owl.trigger( 'next.owl.carousel' );
			// and stop YouTube video
			carousel.$this.find('iframe').each( function() {
		    $( this )[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
			} );
		} );

		function callback( e ) {
			$( '.load-image' ).imageLoader({
				ready: function(prop) {},
				resize: function(prop) {}
			});
			carousel.$this.icons.init( '.svg-icon' );
		}

};

export { carousel };
